// extracted by mini-css-extract-plugin
export var aircallIframe = "_l2-3";
export var fabContainer = "_l2-5";
export var fabRinging = "_l2-6";
export var loadingOverlay = "_l2-4";
export var pulse = "_l2-7";
export var widgetContent = "_l2-2";
export var widgetPanel = "_l2-0";
export var widgetPanelExpanded = "_l2-1";